import { Botao } from './Botao.js';
import { IconeAtencao } from './Icones.js';
import './FalhaDeCarregamento.css';

type Props = {
  /** Mensagem já traduzida por `api/erros.ts`. */
  readonly mensagem: string;
  readonly aoTentarDeNovo: () => void;
};

/**
 * A listagem não carregou.
 *
 * Não é estado vazio: vazio afirma que não há registro, e afirmar isso sem ter
 * conseguido perguntar seria mentir sobre o armazém. Aqui a tela diz que não
 * sabe, e oferece o caminho de tentar de novo.
 */
export function FalhaDeCarregamento({ mensagem, aoTentarDeNovo }: Props) {
  return (
    <div className="falha-carregamento" role="alert">
      <span className="falha-carregamento__icone">
        <IconeAtencao tamanho={20} />
      </span>
      <p className="falha-carregamento__texto">{mensagem}</p>
      <Botao variante="secundario" altura="media" onClick={aoTentarDeNovo}>
        Tentar de novo
      </Botao>
    </div>
  );
}
